export function render(result, element) {
    result.renderInto(element);
}
//# sourceMappingURL=render.js.map